import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=e9dcf34c&scoped=true&"
import script from "./contact.js?vue&type=script&lang=js&"
export * from "./contact.js?vue&type=script&lang=js&"
import style0 from "./contact.scss?vue&type=style&index=0&id=e9dcf34c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9dcf34c",
  null
  
)

export default component.exports